module.exports = __webpack_public_path__ + "static/media/ally-ups-product-img@2x.b29e7b76.png";